module.exports = __webpack_public_path__ + "img/Australia.8a8acd6.webp";